import React, { useCallback } from 'react';
import Link from 'next/link';
import GridItem from '@/components/material-ui-kit/components/Grid/GridItem';
import Card from '@/components/material-ui-kit/components/Card/Card';
import CardHeader from '@/components/material-ui-kit/components/Card/CardHeader';
import CardBody from '@/components/material-ui-kit/components/Card/CardBody';
import CardFooter from '@/components/material-ui-kit/components/Card/CardFooter';
import Muted from '@/components/material-ui-kit/components/Typography/Muted';
import Tooltip from '@material-ui/core/Tooltip';
import Button from '@/components/common/ui/Button';
import { makeStyles } from '@material-ui/core/styles';
import styles from 'styles/jss/original/components/favorites/favoriteShoppingListItem';
import classNames from 'classnames';
import CurrencyFormat from 'react-currency-format';
import { IShopping } from '@/@types/generated/contentful';

// @ts-expect-error
const useStyles = makeStyles(styles);

type ComponentProps = {
  shopping: IShopping;
  onRequestUpdateFavorite: (id: string) => void;
  invalid: boolean;
};

const FavoriteShoppingListItem: React.FC<ComponentProps> = ({
  shopping,
  onRequestUpdateFavorite,
  invalid
}) => {
  const classes = useStyles();
  const handleClick = useCallback(
    (id: string) => {
      onRequestUpdateFavorite(id);
    },
    [onRequestUpdateFavorite]
  );

  return (
    // @ts-expect-error
    <GridItem xs={6} sm={4} md={4} className={classes.flex}>
      <Card product plain className={classes.card}>
        <CardHeader image plain>
          <Link href={`/shoppings/${shopping.fields.slug}`}>
            <a>
              <picture>
                <source
                  srcSet={`${shopping.fields.thumbnail.fields.file.url}?fm=webp`}
                  media='(min-width: 641px)'
                />
                <source
                  srcSet={`${shopping.fields.thumbnail.fields.file.url}?fm=webp&fit=pad&w=400`}
                  media='(max-width: 640px)'
                />
                <img
                  src={`${shopping.fields.thumbnail.fields.file.url}?fit=pad&w=720`}
                  alt={shopping.fields.title}
                />
              </picture>
              <div className={classes.coloredShadow} />
            </a>
          </Link>
        </CardHeader>
        <CardBody className={classes.cardBody} plain>
          <Link href={`/shoppings/${shopping.fields.slug}`}>
            <a>
              <h4 className={classes.cardTitle}>{shopping.fields.title}</h4>
              <Muted>
                <h6 className={classes.cardCategory}>{shopping.fields.cat}</h6>
              </Muted>
            </a>
          </Link>
        </CardBody>
        <CardFooter plain>
          <div className={classes.priceContainer}>
            <span className={classes.price}>
              <CurrencyFormat
                value={shopping.fields.price}
                displayType={'text'}
                thousandSeparator={true}
                prefix={'¥'}
              />
            </span>
          </div>
          <div className={classNames(classes.stats, classes.mlAuto)}>
            <Tooltip
              id='tooltip-top'
              title='削除する'
              placement='top'
              classes={{ tooltip: classes.tooltip }}
            >
              <Button
                justIcon
                simple
                color='gray'
                disabled={invalid}
                onClick={() => handleClick(shopping.fields.id)}
              >
                <i className='fas fa-times' />
              </Button>
            </Tooltip>
          </div>
        </CardFooter>
      </Card>
    </GridItem>
  );
};

export default FavoriteShoppingListItem;
